/***
 *
 * @file components/InteractiveImage/index.tsx
 * @description InteractiveImage component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

"use client";

import React, { ReactNode } from "react";
// import "./InteractiveImage.scss";
import ImageWrapper from "../ImageWrapper";
import { inputToNumber } from "@/helpers/utils.helper";
import classNames from "classnames";

type Props = {
  imageHeight?: string,
  imageWidth?: string,
  src: string,
  areas: string,
  eventName?: string,
  children?: ReactNode,
}

const InteractiveImage = ({ imageHeight = "100px", imageWidth = "100px", children, eventName = '', src = `https://placehold.co/${imageWidth}x${imageHeight}`, areas = "", ...props }: Props) => {
  let areaList = []
  try {
    areaList = JSON.parse(areas);
    areaList?.forEach((a: any) => {
      const coords = a?.coords?.split(',');
      let xcoords = 0;
      let ycoords = 0;
      for (let i = 0; i < coords?.length - 1; i = i + 2) {
        xcoords = xcoords + Number(coords[i]);
        ycoords = ycoords + Number(coords[i + 1]);
      }
      const xcentre = Math.ceil(xcoords / (coords?.length / 2));
      const ycentre = Math.ceil(ycoords / (coords?.length / 2));
      a.xcentre = xcentre;
      a.ycentre = ycentre;
    })
  }
  catch (e) {
    console.error("Error in parsing areas of interactive image: ", e)
  }
  return (
    <div className="InteractiveImage-container" data-testid="InteractiveImage">
      <div className={classNames('relative w-full h-full min-h-[300px]')} onClick={(e) => window.dispatchEvent(new Event(eventName))}>
        <ImageWrapper
          src={src}
          width={inputToNumber(imageWidth)}
          height={inputToNumber(imageHeight)}
          useMap="#image-map"
        />
        <map className="cursor-pointer" name="image-map">
          {Array.isArray(areaList) && areaList?.map((a, i) => {
            return <area
              key={`InteractiveImage--${i}`}
              {...(() => {
                if (a?.type === "openModal") {
                  return {
                    onClick: (e) => {
                      e?.stopPropagation()
                      const left = a?.xcentre + "px";
                      const top = a?.ycentre + "px";
                      window.dispatchEvent(new Event(eventName));
                      window.dispatchEvent(new CustomEvent(a?.openEventName, { detail: { top, left } }));
                    }
                  }
                }
                return {
                  target: a?.target || "_blank",
                  href: a?.href || "/"
                }
              })()}
              alt={a?.title || ""} title={a?.title || ""} coords={a?.coords || ""} shape="poly" />
          })}
        </map>
        {children}
      </div>
    </div>
  );
};

export default InteractiveImage;
